import { message, Spin } from 'antd'
import { startTransition, useEffect, useState } from 'react'

import { CartDrawer } from '@api/home/detail/addCart/useAddCart'
import { useCartListDrawer } from '@api/home/detail/addCart/useCartListDrawer'
import { addCart } from '@api/home/shopCart/action'
import useGlobalEvent, { dispatchGlobalEvent } from '@hooks/useGlobalEvent'

import ProductItem from './components/ProductItem'
import ProductListSkeleton from './components/Skeleton'
import styles from './index.module.scss'

interface ProductListProps {
  column?: number // 一行显示几个产品
  showAddCart?: boolean // 是否显示 add to cart 按钮
  list: any[]
  showSoldOut?: boolean
  showStartInFd?: boolean // 是否显示闪购未开始标签
  showSkeletonList?: boolean // 是否现实骨架屏
  name?: string
  isFeed?: boolean // feed落地页样式保留旧的，不改版
  // isFromItem?: boolean
}

const ProductList: React.FC<ProductListProps> = (props) => {
  const {
    column,
    list,
    isFeed,
    showAddCart,
    showSoldOut,
    showStartInFd,
    showSkeletonList,
    name
  } = props
  const [proList, setProList] = useState([...list])

  useEffect(() => {
    setProList(list)
  }, [list])

  const handler = useCartListDrawer({
    title: 'My Cart',
    isRefetch: true
  })

  const handleAddCart = (item: any) => {
    if (isFeed) {
      dispatchGlobalEvent('listAddCartFromFeed', item)
      return
    }

    addCart({
      products_id: item.productsId,
      sku_id: item.productsSkuId,
      quantity: 1
    }).then(() => {
      handler.setOpen(true)
      dispatchGlobalEvent('refetchCategoryList')
      message.success('SUCCESS!')
    })
  }

  const [isLoading, useLoading] = useState(false)

  //从feed页面接收添加购物车的命令
  useGlobalEvent('receiveAddCartFromFeed', (item) => {
    useLoading(true)
    addCart({
      products_id: item.productsId,
      sku_id: item.productsSkuId,
      quantity: 1
    })
      .then(() => {
        // handler.setOpen(true)
        dispatchGlobalEvent('refetchCategoryList')
        message.success('SUCCESS!')
      })
      .finally(() => {
        useLoading(false)
      })
  })

  return (
    <div>
      {showSkeletonList ? (
        <ProductListSkeleton column={column} />
      ) : (
        <Spin spinning={isLoading} indicator={null}>
          <div className={styles['product-list']}>
            {proList?.map((item: any, index: number) => {
              return (
                <ProductItem
                  key={index}
                  data={item}
                  column={column}
                  isFeed={false}
                  showCartIcon={false}
                  showAddCart={false}
                  showSoldOut={showSoldOut}
                  showStartInFd={showStartInFd}
                  addCartSuccess={handleAddCart}
                  module={name}
                ></ProductItem>
              )
            })}
            {showAddCart && <CartDrawer {...handler} />}
          </div>
        </Spin>
      )}
    </div>
  )
}

export default ProductList
